exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Mixer {\n  display: flex;\n  width: 100%;\n  max-width: 800px; }\n  .Mixer-track {\n    width: 72px;\n    margin-right: 24px; }\n    .Mixer-track:last-child {\n      margin-right: 0; }\n", ""]);

// exports
